import { Tabs } from "antd";
import { useTranslation } from "react-i18next";

import { ObservationItem } from "@/components/Observation/Observation.type";
import ObservationSummary from "@/components/Observation/ObservationSummary";
import ObservationTabs, {
  getCommentTabItem,
} from "@/components/Observation/ObservationTabs";
import { useThemeBreakpoints } from "@/services/theme";

import GridPanel from "./ObservationModalGridPanel";

import "./ObservationModalContent.style.less";

const ObservationModalContent = ({ observation }) => {
  const { t } = useTranslation();
  const { xl, xxl } = useThemeBreakpoints();

  if (xxl) {
    return (
      <div className="observation-modal-content -grid-col-3">
        <GridPanel scrollable>
          <ObservationSummary observation={observation} />
        </GridPanel>
        <GridPanel divider>
          <ObservationTabs observation={observation} />
        </GridPanel>
        <GridPanel divider>
          <Tabs items={[getCommentTabItem(observation, t)]} />
        </GridPanel>
      </div>
    );
  }

  if (xl) {
    return (
      <div className="observation-modal-content -grid-col-2">
        <GridPanel scrollable>
          <ObservationSummary observation={observation} />
        </GridPanel>
        <GridPanel divider>
          <ObservationTabs observation={observation} />
        </GridPanel>
      </div>
    );
  }

  return (
    <div className="observation-modal-content">
      <ObservationTabs observation={observation} />
    </div>
  );
};

ObservationModalContent.propTypes = {
  observation: ObservationItem,
};

export default ObservationModalContent;
